<template>
  <div class="has-text-centered">
    <div class="barcode-search" v-if="permissions.addUpdatePurchase">
      <b-field>
        <b-input
          v-model="barcode"
          :placeholder="$t('purchases.barcode')"
          type="tel"
          icon="barcode"
          @input.native="formatOnlyDigits('barcode')"
        ></b-input>

        <p class="control">
          <button
            class="button"
            :style="{
              backgroundColor: $primaryColor,
              color: $primaryColorContrast
            }"
            @click="$emit('search-product', barcode)"
          >
            {{ $t("purchases.add") }}
          </button>
        </p>
      </b-field>
    </div>

    <div v-if="permissions.bulkAddUpdatePurchases" class="inline">
      &nbsp;
      <b-tooltip
        :label="$t('purchases.processingFile')"
        v-if="processingPurchases"
      >
        <button class="button" :disabled="true">
          <b-icon icon="file-upload"></b-icon>
          &nbsp;&nbsp;&nbsp;{{ $t("purchases.costsSpreadsheet") }}
        </button>
      </b-tooltip>

      <button class="button" @click="$refs.bulkAddPurchases.click()" v-else>
        <b-icon icon="file-upload"></b-icon>
        &nbsp;&nbsp;&nbsp;{{ $t("purchases.costsSpreadsheet") }}
      </button>

      <input
        type="file"
        ref="bulkAddPurchases"
        id="bulk-add-purchases"
        style="display: none"
        accept=".xls,.xlsx"
        @change="bulkAddPurchases"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../mixins/mask";
import { common } from "../../mixins/common";

export default {
  props: ["processingPurchases"],

  mixins: [mask, common],

  data() {
    return {
      barcode: ""
    };
  },

  methods: {
    bulkAddPurchases(event) {
      const file = this.getValidSpreadsheetFile(event);

      if (!file) return;

      const formData = new FormData();

      formData.append("file", file);

      this.isLoading = true;
      this.$store
        .dispatch("bulkAddPurchases", formData)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.dialog.alert({
              title: this.$t("common.success"),
              message: `${this.$t("common.waitProcessingTimeNote1")} ${res.data
                .payload.minutes || 2} ${this.$t(
                "common.waitProcessingTimeNote2"
              )}`,
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
          this.$emit("processing-purchases");
        });
    }
  },

  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>

<style scoped>
.barcode-search {
  display: inline-block;
}
.inline {
  display: inline;
}
</style>
